import Api from "@/api/api";
import {ModalContext} from "@/contexts";
import {IGetClientsResponse,} from "@/interfaces/interface";
import {Form, Modal} from "@/shared";
import {useContext, useState} from "react";
import "./AddClientModal.scss";
import {toast} from "react-toastify";

type FormErrorsType = {
  firstName?: string;
  lastName?: string;
  email?: string;
  name?: string;
  contactInfo?: string;
  billingInfo?: string;
};

type FormValueType = {
  firstName: string;
  lastName: string;
  email: string;
  name: string;
  contactInfo: string;
  billingInfo: string;
};

type Props = {
  getClients: () => Promise<void>;
};

export function AddClientModal({getClients}: Props) {
  const {closeModal} = useContext(ModalContext);

  const [loading, setLoading] = useState(false);

  const [formError, setFormError] = useState<FormErrorsType>({});

  const [formValue, setFormValue] = useState<FormValueType>({
    firstName: '',
    lastName: '',
    email: "",
    name: "",
    contactInfo: "",
    billingInfo: "",
  });

  const {firstName, lastName, email, name, billingInfo, contactInfo} = formValue;

  const validate = () => {
    const errors: FormErrorsType = {};
    const requiredFields: Partial<keyof FormErrorsType>[] = ["email", "name"];
    requiredFields.forEach((field) => {
      if (!formValue[field]) {
        errors[field] = "Required field";
      }
    });

    if (name?.length < 4) {
      errors.name = "Org Name should be longer than 3 symbols";
    }
    if (contactInfo?.length < 4) {
      errors.contactInfo = "Contact info should be longer than 3 symbols";
    }
    if (billingInfo?.length < 4) {
      errors.billingInfo = "Billing info should be longer than 3 symbols";
    }
    if (firstName?.length < 2) {
      errors.firstName = "First name should be longer than 1 symbols";
    }
    if (lastName?.length < 2) {
      errors.lastName = "Last name should be longer than 1 symbols";
    }

    if (!/^[A-Z0-9._%+-]+@[A-Z0-9-]+.+.[A-Z]{2,4}$/i.test(email)) {
      errors.email = "Invalid email address";
    }

    if (Object.keys(errors).length) {
      return errors;
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const {name, value} = event.target;

    setFormValue((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  const handleAddCoach = async () => {
    const errors = validate();
    if (errors) {
      setFormError(errors);
      return;
    }
    setLoading(true);

    try {
      const res = await Api.post<IGetClientsResponse>(`/v2/admin/organizations`, {
        firstName,
        lastName,
        name,
        email,
        billingInfo,
        contactInfo,
      });
      if (res.status === 200) {
        await getClients();
        closeModal();
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message || "Some error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal>
      <Modal.Header text="Add Org Admin"/>

        <Form.Row>
            <Form.Label>Coach First Name</Form.Label>
            <Form.Input
                maxLength={40}
                name="firstName"
                placeholder="Enter First name"
                value={firstName}
                errorMessage={formError.firstName}
                onChange={handleChange}
            />
        </Form.Row>

       <Form.Row>
         <Form.Label>Coach Last Name</Form.Label>
         <Form.Input
                maxLength={40}
                name="lastName"
                placeholder="Enter Last name"
                value={lastName}
                errorMessage={formError.lastName}
                onChange={handleChange}
         />
      </Form.Row>

      <Form.Row>
        <Form.Label>Org Name</Form.Label>
        <Form.Input
          maxLength={40}
          name="name"
          placeholder="Enter name"
          value={name}
          errorMessage={formError.name}
          onChange={handleChange}
        />
      </Form.Row>

      <Form.Row>
        <Form.Label>Email address</Form.Label>
        <Form.Input
          name="email"
          placeholder="Enter email address"
          value={email}
          errorMessage={formError.email}
          onChange={handleChange}
        />
      </Form.Row>

      <Form.Row>
        <Form.Label>Contact info</Form.Label>
        <Form.Input
          value={contactInfo || ""}
          errorMessage={formError.contactInfo}
          placeholder="Enter contact info"
          name={"contactInfo"}
          maxLength={50}
          onChange={handleChange}
        />
      </Form.Row>

      <Form.Row>
        <Form.Label>Billing info</Form.Label>
        <Form.Input
          value={billingInfo || ""}
          placeholder="Enter billing info"
          errorMessage={formError.billingInfo}
          name={"billingInfo"}
          maxLength={50}
          onChange={handleChange}
        />
      </Form.Row>

      <Modal.Footer>
        <Form.Button type="outline" onClick={closeModal}>
          CANCEL
        </Form.Button>

        <Form.Button loading={loading} onClick={handleAddCoach}>
          ADD
        </Form.Button>
      </Modal.Footer>
    </Modal>
  );
}
